import React from 'react';
import { Project } from '../types';
import ProjectCard from './ProjectCard';
import AddSpecCard from './AddSpecCard';
import { useProjectLibraryContext } from '../contexts/ProjectLibraryContext';
import { useNavigateWithinOrg } from '../utils/navigation';
import AddProjectCard from './AddProjectCard';
import useURLParams from '../hooks/useURLParams';

const ProjectGallery: React.FC = () => {
    const navigate = useNavigateWithinOrg();
    const {
        state: { projects, userDetailsMapping },
    } = useProjectLibraryContext();
    const { setParam } = useURLParams();

    const handleSelect = (project: Project) => {
        navigate(`/projects/${project.id}`);
    };

    return (
        <div className="results-table-grid">
            <AddProjectCard
                onSelect={() => {
                    setParam('modal', 'create');
                }}
            />
            {projects.length > 0 ? (
                projects.map((projects) => (
                    <ProjectCard
                        key={projects.id}
                        project={projects}
                        userDetails={
                            userDetailsMapping[projects.creation.user_id]
                        }
                        onSelect={(item) => {
                            handleSelect(item);
                        }}
                    />
                ))
            ) : (
                <p className="no-results-message">No results for this filter</p>
            )}
        </div>
    );
};

export default ProjectGallery;
